import { LoginService } from '../services/login.service';
import {ViewmemberdetailsService} from '../services/viewmemberdetails.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder }  from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {Router} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-confirmotp',
  templateUrl: './confirmotp.component.html',
  styleUrls: ['./confirmotp.component.css']
})
export class ConfirmotpComponent implements OnInit {

  validTitle:string="This is required";
    forgotval:number; loginfrm:FormGroup; logspinner:boolean; userProfileID:any;
    isregister:any=false;
    constructor(private service:LoginService, private route:Router,private fBuilder: FormBuilder, private memberservice : ViewmemberdetailsService) 
    { 
         this.loginfrm = this.fBuilder.group({
        "loginemail": new FormControl("", Validators.compose([
        Validators.required,Validators.pattern("^[0-9]{4}$")
        ]))
      });
    }
       
    
    get loginemail(){ return this.loginfrm.get('loginemail');}
  
    ngOnInit(): void {
      this.userProfileID = localStorage.getItem("userprofileid");

          if(localStorage.getItem('screen')=="Registration")
          {
              this.isregister = true;
          }
    }
  
  
    createLoginPost = function(user1: HTMLInputElement)
    {
      this.logspinner = true;
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let body = new FormData();
      body.append('MemProfileID', localStorage.getItem('userprofileid'));
      body.append('MemID', localStorage.getItem('userid'));
      body.append('MemOTP', user1['loginemail']);
      this.service.authenticationUrl(body,headers).subscribe(Response =>{
      this.loginresponsestatus=Response.status;
      if(Response.status==1) 
      {
          console.log("confirmotp=====>"+JSON.stringify(Response))
          localStorage.setItem('UserMemberID',Response['data'].MemberID);
          localStorage.setItem('UserProfileID',Response['data'].MemberProfileID);
          localStorage.setItem('UserCasteCode',Response['data'].MemberCasteCode);
          localStorage.setItem('UserFullName',Response['data'].MemberFullName);
          localStorage.setItem('UserGender',Response['data'].MemberGender);
          localStorage.setItem('UserHeight',Response['data'].MemberHeight);
          localStorage.setItem('UserMartialStatus',Response['data'].MemberMartialStatus);
          localStorage.setItem('UserCasteID',Response['data'].MemberCasteID);
          localStorage.setItem('UserCasteName',Response['data'].MemberCasteName);
          localStorage.setItem('UserIsApprove',Response['data'].MemberIsApprove);
          localStorage.setItem('UserIsPaid',Response['data'].MemberIsPaid);
          localStorage.setItem('UserRegistrationDt',Response['data'].MemberRegistrationDt);
          localStorage.setItem('UserAge',Response['data'].MemberAge);
          localStorage.setItem('UserDOB',Response['data'].MemberDOB);
          localStorage.setItem('UserIsPhotoUpload',Response['data'].MemberIsPhotoUpload);
          localStorage.setItem('UserPhotoPath',Response['data'].MemberPhotoPath);
          localStorage.setItem('UserCountryID',Response['data'].MemberCountryID);
          localStorage.setItem('UserCountryName',Response['data'].MemberCountryName);
          localStorage.setItem('UserStateID',Response['data'].MemberStateID);
          localStorage.setItem('UserStateName',Response['data'].MemberStateName);
          localStorage.setItem('UserCityID',Response['data'].MemberCityID);
          localStorage.setItem('UserCityName',Response['data'].MemberCityName);
          localStorage.setItem('UserEduID',Response['data'].MemberEduID);
          localStorage.setItem('UserHeightsEducation',Response['data'].MemberHeightsEducation);
          localStorage.setItem('UserEduGroupID',Response['data'].MemberEduGroupID);
          localStorage.setItem('UserEductionGroupName',Response['data'].MemberEductionGroupName);
          localStorage.setItem('UserEmployedIn',Response['data'].MemberEmployedIn);
          localStorage.setItem('UserOccGroupID',Response['data'].MemberOccGroupID);
          localStorage.setItem('UserOccupGroupName',Response['data'].MemberOccupGroupName);
          localStorage.setItem('UserOccID',Response['data'].MemberOccID);
          localStorage.setItem('UserOccupation',Response['data'].MemberOccupation);
          localStorage.setItem('UserJobCountryName',Response['data'].MemberJobCountryName);
          localStorage.setItem('UserJobCity',Response['data'].MemberJobCity);
          localStorage.setItem('UserFamilyStatus',Response['data'].MemberFamilyStatus);
          localStorage.setItem('UserFamilyType',Response['data'].MemberFamilyType);
          localStorage.setItem('UserFamilyValue',Response['data'].MemberFamilyValue);
          localStorage.setItem('UsercasteView',Response['data'].MembercasteView);
          localStorage.setItem('UserSentIntCnt',Response['data'].MemberSentIntCnt);
          localStorage.setItem("MemberOTPVerified",'1');

          let headers = new Headers({ 'Content-Type': 'application/json' });
          let body = new FormData();
          body.append('CasteID', '5');

          this.service.appversionUrl(body,headers).subscribe(Result =>{
            console.log(Result)
          if(Result.status==1) 
          { 
            localStorage.setItem('UserAppCode',Result['data'][0].AppCode);
            localStorage.setItem('UserAppDiscountBannerFlag',Result['data'][0].AppDiscountBannerFlag);
            localStorage.setItem('UserAppInterestLimit',Result['data'][0].AppInterestLimit);
            localStorage.setItem('UserAppRateusFlag',Result['data'][0].AppRateusFlag);
            localStorage.setItem('UserAppURL',Result['data'][0].AppURL);
            localStorage.setItem('UserAppversion',Result['data'][0].Appversion);  
            localStorage.setItem('AppMaleLimit',Result['data'][0].AppMaleLimit); 
            localStorage.setItem('AppFemaleLimit',Result['data'][0].AppFemaleLimit); 
            localStorage.setItem('AppOneMonthFlag',Result['data'][0].AppOneMonthFlag); 
            localStorage.setItem('AppThreeMonthFlag',Result['data'][0].AppThreeMonthFlag); 
            localStorage.setItem('AppSixMonthFlag',Result['data'][0].AppSixMonthFlag); 
            localStorage.setItem('AppYearFlag',Result['data'][0].AppYearFlag);


            if(localStorage.getItem('UserIsPaid')=='1')
            {
              let headers = new Headers({'Content-Type' : 'Application/json'})
              let body = new FormData

              body.append('VwName', localStorage.getItem('UsercasteView'));
              body.append('MemberID',localStorage.getItem('UserMemberID'));
              body.append('MembIsPaid', '1'); 
              body.append('LoggedUserid',localStorage.getItem('UserMemberID')); 

              this.memberservice.memberdetails(body,headers).subscribe(memberresponce =>{
                    localStorage.setItem('MemberSubExpiryDate',memberresponce['data'].MemberSubscriptionExpiredOn); 
                    this.logspinner = false;
                    let link = ['/my-matches'];
                    this.route.navigate(link);
              })

            }
            else
            {

              this.logspinner = false;
              let link = ['/my-matches'];
              this.route.navigate(link);

            }


            
          } 


        })

          
      } 
      else 
      {
          this.opensweetalertdng(Response.message);
          this.logspinner = false;
      }

      },
      error => {
        Swal.fire('Oops...', "Connection Error", 'info');
        this.logspinner = false;
      })
  
    }


    opensweetalert()
    {
      Swal.fire({
          text: 'Login Successfully',
          icon: 'success'
        });
    }
    opensweetalertdng(message)
    {
     Swal.fire('Authentication Failed', message, 'error')
    }


}
